import { render, staticRenderFns } from "./user-vip.vue?vue&type=template&id=e4adef78&scoped=true&"
import script from "./user-vip.vue?vue&type=script&lang=js&"
export * from "./user-vip.vue?vue&type=script&lang=js&"
import style0 from "./user-vip.vue?vue&type=style&index=0&id=e4adef78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4adef78",
  null
  
)

export default component.exports